<script setup>
import { formatNumber } from "@/utils/strings"
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  points: {
    type: Number,
    required: true,
  },
})

const displayPoints = computed(() => {
  return isNaN(props.points) ? 0 : props.points
})

</script>

<template>
  <p class=" mb-0 ">
    {{ text }}:
    <span class="mx-1">
      {{ formatNumber(displayPoints) }}
    </span>
    <VIcon
      class="mr-1"
      icon="ri-trophy-line"
      color="warning"
    />
  </p>
</template>

